import {type MouseEventHandler} from 'react';
import {FormattedMessage} from 'react-intl';
import {Button, type ButtonProps, type Theme} from '@mui/material';
import {Add} from '@mui/icons-material';
import {makeStyles} from '@mui/styles';

const useStyles = makeStyles((theme : Theme) => ({
  root: {
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      whiteSpace: 'normal',
    }
  }
}), {name: 'AddButton'});

export type AddButtonProps = ButtonProps & {
  labelId: string;
  onClick?: MouseEventHandler;
};

const AddButton = ({labelId = 'button.add', ...props} : AddButtonProps) : JSX.Element => {
  const classes = useStyles();
  return (
    <Button className={classes.root} startIcon={<Add />} variant='reversed-contained' size='large' {...props}>
      <FormattedMessage id={labelId} />
    </Button>
  );
};

export default AddButton;